import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";

export const collectionType =
  blocksOptionsConfig.collectionTypes.advBanner.value;

export const config = newCollectionTemplate({
  typeFields: {
    title: "text",
    subTitle: "text",
    slug: "text",
    image: "image",
    isShow: "boolean",
    alt: "text",
  },
  itemTemplate: {
    title: "",
    subTitle: "",
    slug: "",
    image: "",
    isShow: true,
    alt: "",
  },
  type: collectionType,
  showAsTitle: "title", // only texts fields
  allowUseSets: false,
});

// export const config1 = {
//   typeFields: {
//     title: "text",
//     subTitle: 'text',
//     slug: 'text',
//     image: "image",
//     isShow: 'boolean',
//     alt: 'text'
//   },
//   itemTemplate: {
//     title: "",
//     subTitle: '',
//     slug: '',
//     image: '',
//     isShow: true,
//     alt: ''
//   },
//   type: collectionType,
//   showAsTitle: "title", // only texts fields
//   allowUseSets: false,
// };

export const initBlockData = {
  title: "Adv banner",
  collections: {
    [collectionType]: {
      ...config,
      items: [],
    },
  },
};
export const initEmptyBlockData = {
  title: "",
  collections: {
    [collectionType]: {
      ...config,
      items: [],
    },
  },
};
